import React from "react";
import LineItemsDoc from "../components/LineItemsDoc";
import { DOC_CONFIGS } from "../lib/docConfigs";

export default function PurchaseOrders() {
  return (
    <div>
      <div className="mb-5"><h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 font-head">Purchase Orders</h1>
        <p className="text-sm text-slate-500 mt-0.5">Raise multi-item purchase orders to suppliers · generate PO PDF</p></div>
      <LineItemsDoc config={DOC_CONFIGS["purchase-orders"]} />
    </div>
  );
}
